import React, { useEffect, useState } from 'react';
import { Card } from '../../shared/components';
import { api } from '../../utils/api';
import QuizRunner from './QuizRunner';
import './Quizzes.css';

export default function Quizzes() {
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get('/api/topics')
      .then(setTopics)
      .catch(() => setError('Unable to load topics right now.'));
  }, []);

  if (selectedTopic) {
    return <QuizRunner topic={selectedTopic} onExit={() => setSelectedTopic(null)} />;
  }

  return (
    <div className="quizzes-page">
      <h1>Practice Quizzes</h1>
      <p className="quizzes-intro">Pick a topic to answer a set of practice questions with instant feedback.</p>
      <p className="quizzes-disclaimer">
        These questions are AI-generated, written to match the style and difficulty of the real exam &mdash; not actual
        NASAA exam questions, which are copyrighted and cannot legally be reproduced. They're a close stand-in for what
        you'll see on test day, not a leaked question bank.
      </p>
      {error && <p className="quizzes-error">{error}</p>}

      <div className="quizzes-topic-list">
        {topics.map((topic) => (
          <Card key={topic.id} className="quizzes-topic-card">
            <h2>{topic.name}</h2>
            <p>{topic.description}</p>
            <span className="quizzes-weight">{topic.exam_weight_pct}% of exam</span>
            <button className="quizzes-start-button" onClick={() => setSelectedTopic(topic)}>
              Start quiz
            </button>
          </Card>
        ))}
      </div>
    </div>
  );
}
